import { render, staticRenderFns } from "./productContentList.vue?vue&type=template&id=a348a76e&scoped=true"
import script from "./productContentList.vue?vue&type=script&lang=js"
export * from "./productContentList.vue?vue&type=script&lang=js"
import style0 from "./productContentList.vue?vue&type=style&index=0&id=a348a76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a348a76e",
  null
  
)

export default component.exports